// frontend/src/utils/fetcher.ts

import axios, { AxiosRequestConfig } from 'axios';

/**
 * 通用数据获取器
 * - 本地开发时直接指向 Firebase Emulator
 * - 生产环境使用相对路径
 */
export const fetcher = async <T = any>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<T> => {
  // 确保以斜杠开头
  const path = url.startsWith('/') ? url : `/${url}`;
  
  // 判断是否为本地开发环境
  const isDevelopment = process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost';
  
  // 本地开发时直接指向模拟器，生产环境使用相对路径
  const baseURL = isDevelopment 
    ? 'http://127.0.0.1:5001/bitcon-d95a8/asia-east1'
    : '';
  
  const fullPath = baseURL + path;

  let response;
  if (path === '/exchangeInfo') {
    // exchangeInfo 需用 POST
    response = await axios.post<T>(fullPath, {}, config);
  } else {
    // 其他接口 GET
    response = await axios.get<T>(fullPath, config);
  }

  return response.data;
};
